import axios from "axios";

const BASE = process.env.VUE_APP_API_ROOT;

export default {
  namespaced: true,

  state: {
    prenotazioni_attive: [],    // stato 0 (BOZZA) e 1 (CONFERMATA)
    prenotazioni_archivio: [],  // stato 2 (CONVERTITA) e 3 (ANNULLATA)
  },

  getters: {
    attive: (state) =>
      [...state.prenotazioni_attive].sort((a, b) => b.timeStamp - a.timeStamp),

    archivio: (state) =>
      [...state.prenotazioni_archivio].sort((a, b) => b.timeStamp - a.timeStamp),

    by_id: (state) => (id) =>
      state.prenotazioni_attive.find((p) => p._id.$oid === id) ||
      state.prenotazioni_archivio.find((p) => p._id.$oid === id) ||
      null,

    count_attive: (state) => state.prenotazioni_attive.length,
  },

  mutations: {
    set_attive(state, list) {
      state.prenotazioni_attive = list;
    },

    set_archivio(state, list) {
      state.prenotazioni_archivio = list;
    },

    add(state, pren) {
      state.prenotazioni_attive.unshift(pren);
    },

    // Sostituisce la prenotazione nella lista corretta in base allo stato.
    // Se lo stato è passato ad archivio (2 o 3), sposta la prenotazione.
    update(state, pren) {
      const id = pren._id.$oid;
      const isArchivio = pren.stato === 2 || pren.stato === 3;

      const idxAttive = state.prenotazioni_attive.findIndex((p) => p._id.$oid === id);
      const idxArchivio = state.prenotazioni_archivio.findIndex((p) => p._id.$oid === id);

      if (isArchivio) {
        if (idxAttive !== -1) state.prenotazioni_attive.splice(idxAttive, 1);
        if (idxArchivio !== -1) {
          state.prenotazioni_archivio.splice(idxArchivio, 1, pren);
        } else {
          state.prenotazioni_archivio.unshift(pren);
        }
      } else {
        if (idxAttive !== -1) {
          state.prenotazioni_attive.splice(idxAttive, 1, pren);
        } else {
          state.prenotazioni_attive.unshift(pren);
        }
      }
    },

    remove(state, id) {
      const idx = state.prenotazioni_attive.findIndex((p) => p._id.$oid === id);
      if (idx !== -1) state.prenotazioni_attive.splice(idx, 1);
      const idxA = state.prenotazioni_archivio.findIndex((p) => p._id.$oid === id);
      if (idxA !== -1) state.prenotazioni_archivio.splice(idxA, 1);
    },
  },

  actions: {
    async fetch_attive({ commit, rootGetters }) {
      const { data } = await axios.get(`${BASE}/admin/prenotazioni/attive`, {
        auth: rootGetters.get_credential,
      });
      commit("set_attive", data);
    },

    async fetch_archivio({ commit, rootGetters }) {
      const { data } = await axios.get(`${BASE}/admin/prenotazioni`, {
        auth: rootGetters.get_credential,
      });
      commit("set_archivio", data.filter((p) => p.stato === 2 || p.stato === 3));
    },

    async fetch_by_id({ rootGetters }, id) {
      const { data } = await axios.get(`${BASE}/admin/prenotazione/${id}`, {
        auth: rootGetters.get_credential,
      });
      return data;
    },

    async crea({ commit, rootGetters }, payload) {
      const { data } = await axios.post(`${BASE}/admin/prenotazioni`, payload, {
        auth: rootGetters.get_credential,
      });
      commit("add", data);
      return data;
    },

    async cambia_stato({ commit, rootGetters }, { id, stato }) {
      await axios.put(
        `${BASE}/admin/prenotazione/${id}/stato`,
        { stato },
        { auth: rootGetters.get_credential }
      );
      const { data } = await axios.get(`${BASE}/admin/prenotazione/${id}`, {
        auth: rootGetters.get_credential,
      });
      commit("update", data);
    },

    async aggiorna_commento({ rootGetters }, { id, commento }) {
      await axios.put(
        `${BASE}/admin/prenotazione/${id}/commento`,
        { commento },
        { auth: rootGetters.get_credential }
      );
    },

    async aggiorna_commento_articolo({ commit, rootGetters }, { id, id_prodotto, commento }) {
      await axios.put(
        `${BASE}/admin/prenotazione/${id}/prodotto/${id_prodotto}/commento`,
        { commento },
        { auth: rootGetters.get_credential }
      );
      const { data } = await axios.get(`${BASE}/admin/prenotazione/${id}`, {
        auth: rootGetters.get_credential,
      });
      commit("update", data);
    },

    async aggiorna_data_ritiro({ commit, rootGetters }, { id, ts }) {
      await axios.put(
        `${BASE}/admin/prenotazione/${id}/data-ritiro`,
        { ts },
        { auth: rootGetters.get_credential }
      );
      const { data } = await axios.get(`${BASE}/admin/prenotazione/${id}`, {
        auth: rootGetters.get_credential,
      });
      commit("update", data);
    },

    async aggiorna_colore({ commit, rootGetters }, { id, id_prodotto, id_colore, qta, nome_serie }) {
      const { data } = await axios.put(
        `${BASE}/admin/prenotazione/${id}/prodotto/${id_prodotto}/colore/${id_colore}`,
        { qta, nome_serie },
        { auth: rootGetters.get_credential }
      );
      commit("update", data);
      return data;
    },

    async elimina_colore({ commit, rootGetters }, { id, id_prodotto, id_colore }) {
      const { data } = await axios.delete(
        `${BASE}/admin/prenotazione/${id}/prodotto/${id_prodotto}/colore/${id_colore}`,
        { auth: rootGetters.get_credential }
      );
      commit("update", data);
    },

    async elimina_prodotto({ commit, rootGetters }, { id, id_prodotto }) {
      const { data } = await axios.delete(
        `${BASE}/admin/prenotazione/${id}/prodotto/${id_prodotto}`,
        { auth: rootGetters.get_credential }
      );
      commit("update", data);
    },

    async elimina({ commit, rootGetters }, id) {
      await axios.delete(`${BASE}/admin/prenotazione/${id}`, {
        auth: rootGetters.get_credential,
      });
      // Il backend elimina sempre definitivamente (hard-delete)
      commit("remove", id);
    },

    async converti({ commit, rootGetters }, { id, payload }) {
      // payload: { ritiro_cod, commento, articoli_override? }
      // Se articoli_override è presente → conversione parziale: la prenotazione
      // rimane CONFERMATA con le quantità residue. Altrimenti → conversione totale.
      const { data } = await axios.post(
        `${BASE}/admin/prenotazione/${id}/converti-ordine`,
        payload,
        { auth: rootGetters.get_credential }
      );
      // Recupera la prenotazione aggiornata e aggiorna lo store
      // (potrebbe essere ancora CONFERMATA in caso di conversione parziale)
      const pren = await axios.get(`${BASE}/admin/prenotazione/${id}`, {
        auth: rootGetters.get_credential,
      });
      commit("update", pren.data);
      return data; // { id_ordine, numero_ordine, id_prenotazione }
    },

    // Handler Socket.IO — chiamato automaticamente da vue-socket.io
    // con il prefisso SOCKET_ + nome evento
    async SOCKET_PRENOTAZIONE_MODIFICATA({ commit, rootGetters }, id) {
      try {
        const { data } = await axios.get(`${BASE}/admin/prenotazione/${id}`, {
          auth: rootGetters.get_credential,
        });
        commit("update", data);
      } catch {
        // La prenotazione potrebbe essere stata eliminata con hard-delete:
        // in quel caso rimuoviamo solo se era una BOZZA (già non visibile)
        commit("remove", id);
      }
    },
  },
};
